import { z } from "zod"

export const AttachmentSchema = z.object({
  download_url: z.url().nullable(),
  file_name: z.string().min(1).optional(),
  original_file_name: z.string().min(1).optional(),
  url_expires_in_seconds: z.number().int().positive().optional(),
  url_expires_at: z.iso.datetime().optional(),
})

const ProductListAttachmentSchema = z.object({
  type: z.literal("productList"),
  products: z.array(
    z.object({
      id: z.string(),
      entityType: z.enum(["product", "variant"]).optional(),
      productId: z.string().optional(),
      variantId: z.string().optional(),
      title: z.string(),
      description: z.string().nullish(),
      price: z.object({ amount: z.number(), currency: z.string() }).optional(),
      compareAtPrice: z.object({ amount: z.number(), currency: z.string() }).optional(),
      priceRange: z.object({ min: z.number(), max: z.number(), currency: z.string() }).nullish(),
      imageUrl: z.string().nullish(),
      url: z.string().nullish(),
      options: z.array(z.object({ name: z.string(), values: z.array(z.string()) })).optional(),
      rating: z.object({ rating: z.number(), count: z.number() }).nullish(),
    }),
  ),
})

const MessageProductAttachmentSchema = z.union([ProductListAttachmentSchema, z.null()])

export type MessageProductAttachment = z.infer<typeof MessageProductAttachmentSchema>

// Safe transform it so, if some does not match, it will be ignored
export const MessageProductAttachmentsSchema = z
  .array(MessageProductAttachmentSchema.catch(null))
  .transform((attachments) => attachments.filter(Boolean))
